export default __webpack_public_path__ + "static/media/unus-sed-leo-leo-logo.08a14ce4.svg";